// extracted by mini-css-extract-plugin
export default {"sectionContainer":"SectionContact_sectionContainer__GC-MW","containerIcons":"SectionContact_containerIcons__24O+x"};